module.exports = __webpack_public_path__ + "01f43047/img/splash-icon.07a7c465.svg";